export enum AppConfigEnvironment {
	Production = 'production',
	Internal = 'internal',
	Development = 'development',
	// Added specifically for MiDAS app config environment
	ProductionUpdates = 'productionUpdates'
}
